var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftTears = function SvgLeftTears(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 496,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 496c44.194 0 80-34.106 80-76.216a72.953 72.953 0 0 0-6.88-30.956L6.875 216l-71.1 170.995C-69.212 396.961-72 408.089-72 419.784-72 461.868-36.169 496 8 496Z",
    fill: "url(#leftTears_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5-37C26.561-37-22 9.774-22 67.525c0 15.083 3.33 29.459 9.33 42.454L88.027 347l96.429-234.507C191.219 98.825 195 83.564 195 67.525 195 9.809 146.404-37 86.5-37Z",
    fill: "url(#leftTears_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "leftTears_svg__a",
    x1: -76.797,
    y1: 200.651,
    x2: 173.001,
    y2: 324.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#106BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053589"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leftTears_svg__b",
    x1: 87.278,
    y1: 347.358,
    x2: -91.424,
    y2: 97.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#106BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053589"
  })))));
};
export default SvgLeftTears;